import { EntityReferences, ExternalEntityReferences } from "../models/mappers";
import { EntityName, ExternalEntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const pitchFields = [
  "gaming_ContactId", // Lookup - contact
  "gaming_AccountId", // Lookup - account
  "modifiedon", // Date
  "gaming_name", // Text
  "ownerid", // Owner
  "gaming_pitchprogramid", // UID
  "gaming_onboardingdecision", // Choice
  "gaming_contentvalidationstatus", // Text
  "gaming_onboardinghubcreated", // Boolean
  "gaming_OnboardingHubProfileId", // Lookup - Onboarding hub profile
  "gaming_HubLastUpdateByContactId", // Lookup - contact
  "gaming_onboardinghubsubmitteddate", // Date
] as const;

export const pitchReferences: EntityReferences<EntityName.gaming_pitchprogram> = {
  [EntityName.account]: ["gaming_AccountId"],
  [EntityName.contact]: ["gaming_ContactId", "gaming_HubLastUpdateByContactId"],
  [EntityName.gaming_onboardinghubprofile]: ["gaming_OnboardingHubProfileId"],
};

export const pitchExternalReferences: ExternalEntityReferences<EntityName.gaming_pitchprogram> = {
  [ExternalEntityName.team]: ["ownerid"],
};

export const pitchKey: AnyEntityField<EntityName.gaming_pitchprogram> = "gaming_pitchprogramid";
